<template>
  <div id="projets">
    <Title :titlePage="titlePage" />
    <v-container fluid class="pa-4 pb-0">

      <div class="filter-bar">
        <v-text-field
          v-model="search"
          placeholder="Rechercher un projet par client / nom"
          prepend-inner-icon="mdi-magnify"
          outlined
          dense
          hide-details
          clearable
          class="filter-search"
          @input="onSearchInput"
          @click:clear="onSearchClear"
        />
      </div>

      <resultList
        :header="headerProjets"
        :items="projets"
        :nbResult="displayItem"
        :type="'projets'"
        @sort="sort"
        :totalItems="totalItems"
        :page="page"
        :canModif="canModif"
        height="calc(87vh - 175px)"
      />

      <div v-if="totalPages > 1" class="pagination-bar">
        <button class="page-btn" :disabled="page === 1" @click="page--">
          <v-icon small>mdi-chevron-left</v-icon>
        </button>
        <span class="page-info">Page {{ page }} / {{ totalPages }}</span>
        <button class="page-btn" :disabled="page === totalPages" @click="page++">
          <v-icon small>mdi-chevron-right</v-icon>
        </button>
      </div>

    </v-container>
  </div>
</template>

<script>
import Title from "@/components/shared/Title";
import ResultList from "@/components/shared/ResultList";
import api from "@/api/user";

export default {
  name: "Projet",
  components: { Title, ResultList },
  data() {
    return {
      titlePage: "Projets en cours",
      search: "",
      column: "date_projet",
      order: "DESC",
      page: 1,
      totalItems: 0,
      totalPages: 0,
      displayItem: process.env.VUE_APP_NB_DISPLAY,
      projets: [],
      canModif: 0,
      searchTimeout: null,
      headerProjets: [
        { text: "CLIENT",             align: "center", sortable: true,  value: "Entreprise.raison_sociale" },
        { text: "DATE",               align: "center", sortable: true,  value: "date_projet", name: "date_projet" },
        { text: "NOM DU PROJET",      align: "center", sortable: true,  value: "nom_projet" },
        { text: "",                   align: "center", sortable: false, value: "bloc_fore" },
        { text: "PERSONNE RENCONTREE", align: "center", sortable: true,  value: "client", name: "Client" },
        { text: "DESCRIPTION",        align: "center", sortable: false, value: "description" },
        { text: "FICHIER JOINT",      align: "center", sortable: false, value: "documents" },
        { text: "ACTIONS",            align: "center", sortable: false, value: "actions" },
      ],
    };
  },
  watch: {
    page() {
      this.getProjets();
    },
  },
  methods: {
    getProjets() {
      const id = this.$store.state.AsUser.id_utilisateur || "";
      const currentUser = this.$store.state.AsUser.id_utilisateur === ""
        ? this.$store.state.user.id_utilisateur
        : this.$store.state.AsUser.id_utilisateur;

      api.getProjets(id, this.displayItem, this.page - 1, this.column, this.order, this.search).then((res) => {
        this.totalItems = res.data.projets.totalItems;
        this.totalPages = res.data.projets.totalPages;
        this.projets = res.data.projets.rows.map(projet => {
          const usersEntreprise = projet.Entreprise.Users.map(u => u.id_utilisateur);
          const client = projet.Personnes.map(p => `${p.civilite} ${p.nom} ${p.prenom}`);
          projet.Documents.forEach(doc => {
            doc.chemin = process.env.VUE_APP_BASE_URL + doc.chemin;
          });
          return {
            ...projet,
            client,
            // #1124 : projets en cours en écriture (usinage : projets BF seulement)
            canModif: this.$peut('projets_en_cours', 'ecriture', usersEntreprise.includes(currentUser)) &&
              (projet.bloc_fore || !this.$regle('projets_en_cours').bf_seulement) ? 1 : 0,
          };
        });
      }).catch(() => {
        this.$store.dispatch('notify', { message: 'Erreur lors du chargement' });
      });
    },
    sort(sortEvent) {
      if (sortEvent.column !== undefined) {
        this.column = sortEvent.column;
        this.page = sortEvent.page;
      }
      if (sortEvent.order !== undefined) {
        this.order = sortEvent.order ? "ASC" : "DESC";
      }
      this.getProjets();
    },
    onSearchInput() {
      clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => {
        this.page = 1;
        this.getProjets();
      }, 350);
    },
    onSearchClear() {
      this.search = "";
      this.page = 1;
      this.getProjets();
    },
    canModified() {
      if (this.$portee('projets_en_cours', 'ecriture') !== 'none') {
        this.canModif = 1;
      }
    },
  },
  created() {
    this.getProjets();
    this.canModified();
  },
};
</script>

<style scoped lang="scss">
#projets {
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
}

.filter-bar {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 10px;
  flex-wrap: wrap;
}

.filter-search {
  max-width: 400px;
}

.pagination-bar {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 6px 0 2px;
}

.page-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border: 1px solid #d0d0d0;
  border-radius: 6px;
  background: #fff;
  cursor: pointer;
  transition: background 0.15s, border-color 0.15s;

  &:hover:not(:disabled) {
    background: #f0f0f0;
    border-color: #0b87ba;
  }

  &:disabled {
    opacity: 0.35;
    cursor: default;
  }
}

.page-info {
  font-size: 0.82rem;
  color: #555;
  font-weight: 500;
  min-width: 90px;
  text-align: center;
}
</style>
